var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcLocation16 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M8.548 14.595C10.03 13.451 14 10.02 14 6.136a6.2 6.2 0 0 0-1.757-4.339A5.93 5.93 0 0 0 8 0a5.93 5.93 0 0 0-4.243 1.797A6.2 6.2 0 0 0 2 6.137c0 3.882 3.971 7.314 5.452 8.458a.89.89 0 0 0 1.096 0M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0",
  clipRule: "evenodd"
})));
export default SvgIcLocation16;